/**
 * EL SELLO QUE NOMBRA AL DECLARANTE — el único valor de
 * `bat.transactions.<pata>_price_source` que prueba que la cifra guardada en
 * `user_<pata>_value` la afirmó UNA PERSONA y no la calculó la aplicación.
 *
 * ⚠️⚠️ VIVE EN `@bat/shared` PORQUE LO LEEN TRES CAPAS Y UN DESACUERDO ENTRE
 * ELLAS ES SILENCIOSO. Lo ESCRIBE el editor «Editar valor fiat»
 * (`backend/platform/transformers/transaction.transformer.ts`,
 * `enrichUpdateRequest`); lo LEE el bloque «Valores declarados por el usuario»
 * del informe fiscal (`user-declared-fiat-value-disclosure.ts`) y lo LEE la
 * rejilla/exportación/Traza para decidir el marcador de la celda «Valor»
 * (`frontend/…/shared/fiat/report-currency-value.ts`). Si cada capa declarase su
 * propio literal, un cambio en uno de ellos apagaría el aviso fiscal y borraría
 * el `*` de la rejilla sin que fallase nada: por eso hay UNA definición y las
 * tres la importan. El backend no puede tomarla del módulo de informes —
 * `platform/` no importa de `modules/` — así que este paquete es el único sitio
 * común que existe.
 *
 * ⚠️ NO ES UN VALOR DE `bat.price_source_configs`, y es deliberado. Aquel
 * catálogo nombra ORÍGENES DE PRECIO (`binance`, `kraken`, `coingecko`, e
 * incluso un `'manual'` que configura un admin); una declaración del
 * contribuyente no es un origen de precio: detrás de ella no hay ninguna
 * cotización que consultar ni ninguna fecha de vela que citar.
 *
 * ⚠️ TAMPOCO ES EL CENTINELA `'fiat'`. Ése significa «el valor guardado ES el
 * importe de esta pata, que ya venía en divisa fiat»
 * (`import-price-enricher.service.ts`): exacto por construcción y afirmado por
 * nadie. Éste significa lo contrario — alguien puede tener que justificarlo.
 */
export const USER_DECLARED_FIAT_VALUE_PRICE_SOURCE = 'user-declared'
